import React, { useEffect, useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { LicenseManagement } from "./UserSidebarData.js";
import { FaHome, FaFileInvoiceDollar } from "react-icons/fa";
// import "./UserSidebar.css";

/* sidebar content */
const UserSideBarContent = () => {
  // The "Request Quote" tab is only relevant to users who already own a license
  // (they manage renewals / additional requests here). Brand-new users without
  // any license keep the existing dashboard request form instead.
  // const [hasLicenses, setHasLicenses] = useState(false);

  // useEffect(() => {
  //   const checkLicenses = async () => {
  //     const token = localStorage.getItem("accessToken");
  //     if (!token) return;
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_URL}/user/license/index`,
  //         { params: { limit: 1, page: 1 }, headers: { authorization: token } }
  //       );
  //       const total = response.data?.meta?.pagination?.total ?? (response.data?.licenses?.length || 0);
  //       setHasLicenses(total > 0);
  //     } catch (err) {
  //       // Silent — tab simply stays hidden if we can't determine license status.
  //     }
  //   };
  //   checkLicenses();
  // }, []);

  return (
    <>
      {/* <UserBox username={props.username} /> */}

      <div id='sidebar-menu' className="ScrollY">
        <ul className='side-menu ' id='side-menu' >

          <li>
            <NavLink to='/User/Dashboard' style={{ textDecoration: 'none' }} activeclassname="active">
              <FaHome />
              <span> Dashboard </span>
            </NavLink>
          </li>
          {/* <li className='menu-title mt-0' style={{fontWeight:'bold'}}>License Management</li> */}
          {LicenseManagement.map((item, index) => {
            // if (item.title === "Request a Quote" && !hasLicenses) {
            //   return null; // Skip rendering this item if the user has no licenses
            // }
            return (
              <li key={index} className='side-nav-item icon-clr'>
                <NavLink to={item.path} className='side-nav-link-ref icon-clr' style={{ textDecoration: 'none' }} activeclassname="active">
                  <i className='feather feather-calendar'>{item.icon}</i>
                  <span> {item.title} </span>
                </NavLink>
              </li>
            );
          })}
          {/* {hasLicenses && (
            <li className='side-nav-item icon-clr'>
              <NavLink to='/User/RequestQuote' className='side-nav-link-ref icon-clr' style={{ textDecoration: 'none' }} activeclassname="active">
                <i className='feather feather-calendar'><FaFileInvoiceDollar /></i>
                <span> Request Quote </span>
              </NavLink>
            </li>
          )} */}
        </ul>
      </div>
    </>
  );
};


export default UserSideBarContent;
